import MomentUtils from "@date-io/moment";
import {
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  withStyles
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { Autocomplete } from "@material-ui/lab";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import React, { useCallback, useEffect, useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import { FaCheck } from "react-icons/fa";
import { GrDocumentPdf } from "react-icons/gr";
import { LuSparkles } from "react-icons/lu";
import { handleKeyDown } from "../../../common/common";
import CustomTooltip from "../../../common/Tooltip";
import MyVesselUploadPDFModal from "../../Common/UploadMyvesselPdf";
const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

function AutoAddFleet(props) {
  const {
    onAddFleetLine,
    addFleetsArray,
    saveVesselListByIndex,
    onChangeNewFleetsValue,
    delayVesselSearch,
    vesselLoading,
    savePortListByIndex,
    delayPortSearch,
    portLoading,
    onDeleteVesselLine,
    onSaveAllVessels,
    setValidationVessel = () => { },
    setValidationVesselIndex = () => { },
    setVesselCreationMode = () => { },
    onCreateWithAI,
  } = props;
  const [getOpenUploadPDF, setOpenUploadPDF] = useState(false);
  const [query, setQuery] = useState(null);
  const [lastValidationSignature, setLastValidationSignature] = useState("");

  // Helper function to map vessel consumption data
  const mapVesselConsumptions = (vesselData) => {
    const ballastConsumptions = vesselData?.Ballast_Sea_Consumptions || {};
    const ladenConsumptions = vesselData?.Laden_Sea_Consumptions || {};
    const portConsumptions = vesselData?.Port_Consumptions || {};

    return {
      // Ballast consumptions
      vesselBalSpd1: ballastConsumptions.col_1?.Speed || 0,
      vesselBalConsmHS1: ballastConsumptions.col_1?.HS || 0,
      vesselBalConsmLS1: ballastConsumptions.col_1?.LS || 0,
      vesselBalConsmMGO1: ballastConsumptions.col_1?.MGO || 0,
      vesselBalSpd2: ballastConsumptions.col_2?.Speed || 0,
      vesselBalConsmHS2: ballastConsumptions.col_2?.HS || 0,
      vesselBalConsmLS2: ballastConsumptions.col_2?.LS || 0,
      vesselBalConsmMGO2: ballastConsumptions.col_2?.MGO || 0,
      vesselBalSpd3: ballastConsumptions.col_3?.Speed || 0,
      vesselBalConsmHS3: ballastConsumptions.col_3?.HS || 0,
      vesselBalConsmLS3: ballastConsumptions.col_3?.LS || 0,
      vesselBalConsmMGO3: ballastConsumptions.col_3?.MGO || 0,
      vesselBalSpd4: ballastConsumptions.col_4?.Speed || 0,
      vesselBalConsmHS4: ballastConsumptions.col_4?.HS || 0,
      vesselBalConsmLS4: ballastConsumptions.col_4?.LS || 0,
      vesselBalConsmMGO4: ballastConsumptions.col_4?.MGO || 0,

      // Laden consumptions
      vesselLdnSpd1: ladenConsumptions.col_1?.Speed || 0,
      vesselLdnConsmHS1: ladenConsumptions.col_1?.HS || 0,
      vesselLdnConsmLS1: ladenConsumptions.col_1?.LS || 0,
      vesselLdnConsmMGO1: ladenConsumptions.col_1?.MGO || 0,
      vesselLdnSpd2: ladenConsumptions.col_2?.Speed || 0,
      vesselLdnConsmHS2: ladenConsumptions.col_2?.HS || 0,
      vesselLdnConsmLS2: ladenConsumptions.col_2?.LS || 0,
      vesselLdnConsmMGO2: ladenConsumptions.col_2?.MGO || 0,
      vesselLdnSpd3: ladenConsumptions.col_3?.Speed || 0,
      vesselLdnConsmHS3: ladenConsumptions.col_3?.HS || 0,
      vesselLdnConsmLS3: ladenConsumptions.col_3?.LS || 0,
      vesselLdnConsmMGO3: ladenConsumptions.col_3?.MGO || 0,
      vesselLdnSpd4: ladenConsumptions.col_4?.Speed || 0,
      vesselLdnConsmHS4: ladenConsumptions.col_4?.HS || 0,
      vesselLdnConsmLS4: ladenConsumptions.col_4?.LS || 0,
      vesselLdnConsmMGO4: ladenConsumptions.col_4?.MGO || 0,

      // Port consumptions
      vesselPIdleConsmHS: portConsumptions.Idle?.HS || 0,
      vesselPIdleConsmLS: portConsumptions.Idle?.LS || 0,
      vesselPIdleConsmMGO: portConsumptions.Idle?.MGO || 0,
      vesselPLdgConsmHS: portConsumptions.Loading?.HS || 0,
      vesselPLdgConsmLS: portConsumptions.Loading?.LS || 0,
      vesselPLdgConsmMGO: portConsumptions.Loading?.MGO || 0,
      vesselPDischConsmHS: portConsumptions.Disch?.HS || 0,
      vesselPDischConsmLS: portConsumptions.Disch?.LS || 0,
      vesselPDischConsmMGO: portConsumptions.Disch?.MGO || 0,
      vesselVExtraConsmHS: portConsumptions.Extra?.HS || 0,
      vesselVExtraConsmLS: portConsumptions.Extra?.LS || 0,
      vesselVExtraConsmMGO: portConsumptions.Extra?.MGO || 0,
    };
  };

  // Helper function to map bunker data
  const mapBunkerData = (splitData) => {
    const bunkerQty = splitData?.bunker_qty || {};
    const bunkerPrice = splitData?.bunker_price || {};

    return {
      bnkDelhs: bunkerQty.bnkDelhs || 0,
      bnkDells: bunkerQty.bnkDells || 0,
      bnkDelmgo: bunkerQty.bnkDelmgo || 0,
      bnkPriceDeliveryhs: bunkerPrice.bnkPriceDeliveryhs || 0,
      bnkPriceDeliveryls: bunkerPrice.bnkPriceDeliveryls || 0,
      bnkPriceDeliverymgo: bunkerPrice.bnkPriceDeliverymgo || 0,
      bnkPriceRedeliveryhs: bunkerPrice.bnkPriceRedeliveryhs || 0,
      bnkPriceRedeliveryls: bunkerPrice.bnkPriceRedeliveryls || 0,
      bnkPriceRedeliverymgo: bunkerPrice.bnkPriceRedeliverymgo || 0,
      bnkPriceSettlemenths: bunkerPrice.bnkPriceSettlemenths || 0,
      bnkPriceSettlementls: bunkerPrice.bnkPriceSettlementls || 0,
      bnkPriceSettlementmgo: bunkerPrice.bnkPriceSettlementmgo || 0,
      bnkQtyRedeliveryhs: bunkerQty.bnkQtyRedeliveryhs || 0,
      bnkQtyRedeliveryls: bunkerQty.bnkQtyRedeliveryls || 0,
      bnkQtyRedeliverymgo: bunkerQty.bnkQtyRedeliverymgo || 0,
      bnkRedeliveryQtyTolerancehs: bunkerQty.bnkRedeliveryQtyTolerancehs || 0,
      bnkRedeliveryQtyTolerancels: bunkerQty.bnkRedeliveryQtyTolerancels || 0,
      bnkRedeliveryQtyTolerancemgo: bunkerQty.bnkRedeliveryQtyTolerancemgo || 0,
    };
  };

  // Update fleet data when query changes
  const updateFleetData = useCallback((query) => {
    if (!query || !addFleetsArray.length) return;

    const lastIndex = addFleetsArray.length - 1;
    const vesselConsumptions = mapVesselConsumptions(query.vesselData);
    const bunkerData = mapBunkerData(query.splitData);

    const updatedFleet = {
      ...addFleetsArray[lastIndex],
      selectedVessel: {
        vesselName: query.vesselName,
        vesselDwt: query.DWT,
        vesselLabel: query.vesselName,
        vesselIMO: query.vesselData?.IMO || 0,
        vesselNRT: query.vesselData?.NRT || 0,
        vesselMMSI: query.vesselData?.MMSI || 0,
        vesselTPC: query.vesselData?.TPC || 0,
        vesselGears: query.vesselData?.Gears || 0,
        vesselGrabs: query.vesselData?.Grabs || 0,
        vesselFlag: query.vesselData?.Flag || 0,
        vesselDraftS: query.vesselData?.Draft || 0,
        vesselClass: query.vesselData?.Class || 0,
        vesselBuilt: query.vesselData?.built || 0,
        vesselGrainCap: query.vesselData?.grain || 0,
        vesselLOA: query.vesselData?.LOA || 0,
        vesselBeam: query.vesselData?.Beam || 0,
        vesselGRT: query.vesselData?.GRT || 0,
        vesselNRT: query.vesselData?.NRT || 0,
        vesselLightShip: query.vesselData?.light_ship || 0,
        vesselBaleCap: query.vesselData?.bale_capacity || 0,

        ...vesselConsumptions,
        // Combinations
        vesselBalComb1Selected: query.vesselData?.BalComb1 || false,
        vesselBalComb2Selected: query.vesselData?.BalComb2 || false,
        vesselBalComb3Selected: query.vesselData?.BalComb3 || false,
        vesselBalComb4Selected: query.vesselData?.BalComb4 || false,
        vesselLadComb1Selected: query.vesselData?.LadComb1 || false,
        vesselLadComb2Selected: query.vesselData?.LadComb2 || false,
        vesselLadComb3Selected: query.vesselData?.LadComb3 || false,
        vesselLadComb4Selected: query.vesselData?.LadComb4 || false,
        vesselExtraDetails: {},
      },
      selectedPort: {
        portLabel: query.Port,
        portName: query.Port
      },
      dateOpen: query?.expenses?.dateOpen,
      gbb: query.gbb,
      hirePerDay: query.hirePerDay,
      hireGbb: query.hireGbb,
      remark: query.remark || "",
      ...bunkerData,
      bunkerPriceOverridden: false,
      vesselName: query.vesselName,
      port: query.Port,
      constants: query.expenses?.constants || 0,
      extraExpense: query.expenses?.extraExpense || 0
    };

    addFleetsArray[lastIndex] = updatedFleet;
  }, [query]);

  useEffect(() => {
    updateFleetData(query);
  }, [query, updateFleetData]);

  useEffect(() => {
    const validationSignature = (Array.isArray(addFleetsArray) ? addFleetsArray : [])
      .map((item, idx) => `${idx}:${item?.isValidate ? 1 : 0}`)
      .join("|");

    const hasAnyVerifiedRow = (Array.isArray(addFleetsArray) ? addFleetsArray : []).some((item) => item?.isValidate);
    const verificationJustTurnedTrue =
      validationSignature !== lastValidationSignature &&
      validationSignature.includes(":1") &&
      !lastValidationSignature.includes(":1");

    if (verificationJustTurnedTrue && hasAnyVerifiedRow && window.handleVesselTourAction) {
      window.handleVesselTourAction("modal_next_clicked");
      window.handleVesselTourAction("verification_complete");
    }

    setLastValidationSignature(validationSignature);
  }, [addFleetsArray, lastValidationSignature]);

  return (
    <div className="h-full">
      <div className="flex flex-col gap-1.5">
        <div className="w-full flex justify-end mb-1">
          <div className="w-fit flex flex-wrap items-center justify-end gap-1.5" data-spotlight="add-vessel-actions">
            <button
              onClick={onAddFleetLine}
              className="flex items-center gap-1.5 px-2.5 py-1 h-[26px] text-[11px] font-medium text-slate-900 bg-white hover:bg-slate-50 border border-slate-300 rounded-none shadow-2xs transition-colors cursor-pointer"
            >
              <BsPlusLg size={10} className="text-[#313C4C]" /> Add Vessel
            </button>
            <button
              className="flex items-center gap-1.5 px-2.5 py-1 h-[26px] text-[11px] font-medium text-slate-900 bg-white hover:bg-slate-50 border border-slate-300 rounded-none shadow-2xs transition-colors cursor-pointer"
              onClick={() => setOpenUploadPDF(true)}
            >
              <GrDocumentPdf size={12} className="text-[#313C4C]" /> Upload PDF
            </button>
            <button
              className="flex items-center gap-1.5 px-2.5 py-1 h-[26px] text-[11px] font-medium text-slate-900 bg-white hover:bg-slate-50 border border-slate-300 rounded-none shadow-2xs transition-colors cursor-pointer"
              onClick={() => {
                setVesselCreationMode("manual");
              }}
            >
              <BsPlusLg size={10} className="text-[#313C4C]" /> Create New Vessel
            </button>
            {onCreateWithAI && (
              <button
                type="button"
                className="flex items-center gap-1.5 px-2.5 py-1 h-[26px] text-[11px] font-medium text-white bg-[#313C4C] border border-[#313C4C] rounded-none shadow-2xs cursor-pointer hover:bg-[#0c2f50] transition-colors"
                onClick={onCreateWithAI}
              >
                <LuSparkles size={14} /> Create with AI
              </button>
            )}
          </div>
        </div>


        <div className="border border-slate-300 rounded-none shadow-2xs bg-white overflow-x-auto w-full">
          <Table className="fleet-list-table" style={{ minWidth: 950 }}>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "20%", minWidth: "160px" }}>
                  Vessel Name
                  <LightTooltip title="Required">
                    <span className="required-span">*</span>
                  </LightTooltip>
                </TableCell>
                <TableCell style={{ width: "8%", minWidth: "65px" }}>DWT</TableCell>
                <TableCell style={{ width: "18%", minWidth: "140px" }}>
                  Port
                  <LightTooltip title="Required">
                    <span className="required-span">*</span>
                  </LightTooltip>
                </TableCell>
                <TableCell style={{ width: "18%", minWidth: "165px" }}>
                  Date Opening
                  <LightTooltip title="Required">
                    <span className="required-span">*</span>
                  </LightTooltip>
                </TableCell>
                {/* <TableCell>GBB</TableCell> */}
                <TableCell style={{ width: "10%", minWidth: "85px" }}>Hire Per Day</TableCell>
                <TableCell style={{ width: "10%", minWidth: "85px" }}>Hire GBB</TableCell>
                <TableCell style={{ width: "16%", minWidth: "120px" }}>Remarks/Broker/etc</TableCell>
                <TableCell style={{ width: "90px", minWidth: "90px", textAlign: "center" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(addFleetsArray) && addFleetsArray.length ? (
                addFleetsArray.map((item, index) => {
                  const {
                    dateOpen = Date.now(),
                    hirePerDay = 0,
                    hireGbb = 0,
                    remark = "",
                    selectedVessel = {},
                    selectedPort = {},
                    isValidate = false,
                  } = item || {};

                  return (
                    <TableRow key={index}>
                      {/* Vessel Name */}
                      <TableCell>
                        <Autocomplete
                          options={(saveVesselListByIndex[index] && saveVesselListByIndex[index]) || []}
                          value={selectedVessel}
                          style={{ width: "100%" }}
                          disableClearable
                          getOptionLabel={(option) => option.vesselLabel || option.vesselName || ""}
                          className="autocomplete-mui"
                          classes={{ paper: "compact-popover" }}
                          data-spotlight="vessel-autocomplete"
                          onChange={(e, value) => {
                            onChangeNewFleetsValue(index, "vesselName", value);
                            if (value && window.handleVesselTourAction) {
                              window.handleVesselTourAction('vessel_selected');
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Search vessel…"
                              value={selectedVessel?.vesselName || ""}
                              onChange={(e) => delayVesselSearch(index, e.target.value)}
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {vesselLoading[index] ? (
                                      <CircularProgress color="inherit" size={12} style={{ position: "absolute", right: 34, top: "calc(50% - 6px)" }} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </TableCell>

                      {/* DWT */}
                      <TableCell>
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          className="custom-input-field block"
                          value={(selectedVessel && selectedVessel.vesselDwt) || 0}
                          disabled
                          onChange={(e) =>
                            onChangeNewFleetsValue(index, "dwt", e.target.value)
                          }
                        />
                      </TableCell>

                      {/* Port */}
                      <TableCell>
                        <Autocomplete
                          options={(savePortListByIndex[index] && savePortListByIndex[index]) || []}
                          value={selectedPort}
                          getOptionLabel={(option) => option.portLabel || ""}
                          style={{ width: "100%" }}
                          disableClearable
                          className="autocomplete-mui"
                          classes={{ paper: "compact-popover" }}
                          data-spotlight="port-autocomplete"
                          onChange={(e, value) => {
                            onChangeNewFleetsValue(index, "port", value);
                            if (value && window.handleVesselTourAction) {
                              window.handleVesselTourAction('port_selected');
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              placeholder="Search port…"
                              value={selectedPort?.portLabel || ""}
                              onChange={(e) => delayPortSearch(index, e.target.value)}
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {portLoading[index] ? (
                                      <CircularProgress color="inherit" size={12} style={{ position: "absolute", right: 34, top: "calc(50% - 6px)" }} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </TableCell>

                      {/* Date Opening */}
                      <TableCell>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                          <DateTimePicker
                            inputVariant="outlined"
                            size="small"
                            className="date-time-picker"
                            style={{ display: "flex" }}
                            value={dateOpen}
                            format="MMM DD, YYYY HH:mm"
                            ampm={false}
                            onChange={(date) =>
                              onChangeNewFleetsValue(index, "dateOpen", date)
                            }
                          />
                        </MuiPickersUtilsProvider>
                      </TableCell>

                      {/* Hire Per Day */}
                      <TableCell>
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          value={hirePerDay}
                          className="custom-input-field block"
                          onChange={(e) =>
                            onChangeNewFleetsValue(index, "hirePerDay", e.target.value)
                          }
                        />
                      </TableCell>

                      {/* Hire GBB */}
                      <TableCell>
                        <input
                          type="number"
                          onKeyDown={handleKeyDown}
                          value={hireGbb}
                          className="custom-input-field block"
                          onChange={(e) =>
                            onChangeNewFleetsValue(index, "hireGbb", e.target.value)
                          }
                        />
                      </TableCell>

                      {/* Remarks */}
                      <TableCell>
                        <input
                          type="text"
                          value={remark}
                          className="custom-input-field large-field"
                          onChange={(e) =>
                            onChangeNewFleetsValue(index, "remark", e.target.value)
                          }
                        />
                      </TableCell>

                      {/* Actions */}
                      <TableCell>
                        <div className="flex items-center gap-1.5 h-[22px]">
                          {selectedVessel?.vesselName && (
                            <CustomTooltip text="Validate or update fleet details">
                              <button
                                onClick={() => {
                                  setValidationVessel(true);
                                  setValidationVesselIndex(index);
                                  if (window.handleVesselTourAction) {
                                    window.handleVesselTourAction('verification_modal_open');
                                  }
                                }}
                                data-spotlight="verify-vessel-btn"
                                className={`flex items-center justify-center gap-1 px-2.5 py-0.5 h-[22px] text-[11px] font-medium text-white rounded-none transition-colors cursor-pointer border-none ${isValidate
                                    ? "bg-emerald-600 hover:bg-emerald-700"
                                    : "bg-amber-600 hover:bg-amber-700"
                                  }`}
                              >
                                {isValidate && <FaCheck size={9} />}
                                {isValidate ? "Verified" : "Verify"}
                              </button>
                            </CustomTooltip>
                          )}

                          {index !== 0 && (
                            <CustomTooltip text="Delete this vessel line">
                              <IconButton
                                size="small"
                                onClick={() => onDeleteVesselLine(index)}
                                style={{
                                  color: "#94a3b8",
                                  padding: 2,
                                  width: 22,
                                  height: 22,
                                  borderRadius: 6,
                                  transition: "color 0.15s, background 0.15s",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.color = "#ef4444";
                                  e.currentTarget.style.background = "#fef2f2";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.color = "#94a3b8";
                                  e.currentTarget.style.background = "transparent";
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </CustomTooltip>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={8}
                    align="center"
                    style={{
                      padding: "40px 16px",
                      color: "#94a3b8",
                      fontSize: "0.875rem",
                      borderBottom: "none",
                    }}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <span style={{ fontSize: "2rem", opacity: 0.35 }}>🚢</span>
                      <span>No vessels added yet. Click <strong>+ Add Vessel</strong> to get started.</span>
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
      <div className="flex justify-end mt-2 mb-1">
        <button
          onClick={() => {
            onSaveAllVessels();
          }}
          className="flex items-center justify-center px-4 h-[26px] text-[11px] font-medium text-white bg-[#313C4C] hover:bg-[#0c2f50] border border-[#313C4C] rounded-none shadow-2xs transition-colors cursor-pointer"
          data-spotlight="save-fleet-btn"
        >
          Add to My Vessels
        </button>
      </div>
      <MyVesselUploadPDFModal open={getOpenUploadPDF}
        handleClose={() => setOpenUploadPDF(false)} setQuery={setQuery}
        query={query} />
    </div >
  );
}

export default AutoAddFleet;
